import {
  RESOLVE_QUEST_COMMENT,
  OPEN_QUEST_COMMENT,
  POST_QUEST_COMMENT,
  POST_ACTIVITY_COMMENT,
  POST_USER_QUEST_COMMENT,
  POST_USER_ACTIVITY_COMMENT,
  REQUEST_QUEST_COMMENTS,
  RECEIVE_QUEST_COMMENTS,
  REQUEST_QUEST_ACTIVITY_COMMENTS,
  RECEIVE_QUEST_ACTIVITY_COMMENTS,
  FETCH_USER_QUEST_COMMENTS_REQUEST,
  FETCH_USER_QUEST_COMMENTS_SUCCESS,
  FETCH_USER_ACTIVITY_COMMENTS_REQUEST,
  FETCH_USER_ACTIVITY_COMMENTS_SUCCESS,
  PUBLISH_DRAFT_QUEST_COMMENT,
  PUBLISH_DRAFT_ACTIVITY_COMMENT,
  EDIT_DRAFT_QUEST_COMMENT,
  EDIT_DRAFT_ACTIVITY_COMMENT,
  EDIT_QUEST_COMMENT,
  EDIT_ACTIVITY_COMMENT,
  DELETE_QUEST_COMMENT,
  DELETE_ACTIVITY_COMMENT,
  DELETE_DRAFT_QUEST_COMMENT,
  DELETE_DRAFT_ACTIVITY_COMMENT,
  IS_EDITING_COMMENT,
  IS_NOT_EDITING_COMMENT
} from '../actions/comments'
import {
  REQUEST_QUEST,
  RECEIVE_QUEST,
  SET_QUEST_SECTION,
  REQUEST_QUEST_NOTES,
  RECEIVE_QUEST_NOTES,
  DELETE_QUEST_SUCCESS,
  EDIT_QUEST_DETAILS_SUCCESS,
  EDIT_QUEST_MENTOR_NOTE_SUCCESS,
  DELETE_NOTE_SUCCESS,
  CREATE_QUEST_MENTOR_NOTE_SUCCESS,
  CREATE_MENTOR_NOTE,
  START_EDIT_QUEST,
  CANCEL_EDIT_QUEST,
  DELETE_NOTE_REQUEST,
  CREATE_QUEST_REQUEST,
  CREATE_QUEST_FAILURE,
  CREATE_QUEST_SUCCESS,
  ADD_EDITOR_TO_QUEST,
  RECEIVE_QUEST_READABLE_STATS,
  EDIT_QUEST_DETAILS_FAILURE,
  RECEIVE_QUEST_ANALYTICS,
  REQUEST_QUEST_ANALYTICS,
  FAILED_QUEST_ANALYTICS,
  EDIT_QUEST_DETAILS_REQUEST,
  FETCH_QUEST_HISTORY_REQUEST,
  FETCH_QUEST_HISTORY_SUCCESS,
  CLEAR_QUEST_HISTORY,
  FETCH_QUEST_ACTIVITIES_SUCCESS,
  FETCH_IN_USE_COMPILED_QUESTS_SUCCESS,
  FETCH_CURRENT_ASSIGNMENT_SUCCESS,
  FETCH_QUEST_APPROVALS_SUCCESS,
  FETCH_QUEST_GRADE_LEVELS_SUCCESS,
  START_FETCHING_QUEST_DATA,
  END_FETCHING_QUEST_DATA,
  UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS
} from '../actions/quest'
import { FETCH_TOPIC_CLOUD_REQUEST } from '../actions/topicclouds'
import {
  REQUEST_QUEST_ACTIVITY_NOTES,
  RECEIVE_QUEST_ACTIVITY_NOTES,
  DELETE_ACTIVITY_SUCCESS,
  EDIT_ACTIVITY_DETAILS_SUCCESS,
  DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS,
  CREATE_QUEST_ACTIVITY_NOTE_SUCCESS,
  EDIT_QUEST_ACTIVITY_NOTE_REQUEST,
  EDIT_QUEST_ACTIVITY_NOTE_SUCCESS,
  EDIT_QUEST_ACTIVITY_NOTE_FAILURE,
  EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS,
  CREATE_ACTIVITY_REQUEST,
  CREATE_ACTIVITY_FAILURE,
  CREATE_ACTIVITY_SUCCESS,
  EDIT_ACTIVITY_POSITION_SUCCESS,
  EDIT_ACTIVITY_DETAILS_REQUEST,
  EDIT_ACTIVITY_DETAILS_FAILURE,
  RECEIVE_ACTIVITY_READABLE_STATS
} from '../actions/activity'
import {
  CREATE_ACTIVITY_RESOURCE_REQUEST,
  CREATE_ACTIVITY_RESOURCE_SUCCESS,
  CREATE_ACTIVITY_RESOURCE_FAILURE,
  PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS,
  REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS,
  EDIT_ACTIVITY_RESOURCE_SUCCESS,
  EDIT_ACTIVITY_RESOURCE_REQUEST,
  EDIT_ACTIVITY_RESOURCE_FAILURE,
  DELETE_ACTIVITY_RESOURCE_SUCCESS,
  EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS
} from '../actions/resource'
import {
  IS_ASSIGNING,
  IS_NOT_ASSIGNING,
  ASSIGN_QUEST_TO_USER_SUCCESS,
  IS_UNASSIGNING,
  IS_NOT_UNASSIGNING,
  UNASSIGN_QUEST_FROM_USER_SUCCESS
} from '../actions/assignment'
import {
  SET_APPROVED_SUCCESS,
  DELETE_APPROVED_SUCCESS,
  IS_EDITING_APPROVAL,
  IS_SETTING_LAST_APPROVAL
} from '../actions/approval'

import {
  OPEN_TO_QUALITY_REVIEW_MODAL,
  CLOSE_TO_QUALITY_REVIEW_MODAL,
  CREATE_COMPILED_QUEST_SUCCESS,
  CREATE_COMPILED_QUEST_REVIEW_SUCCESS,
  DELETE_COMPILED_QUEST_REVIEW_SUCCESS,
  COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS,
  EDIT_REVIEW_SUCCESS,
  REQUEST_CURRENT_COMPILED_QUEST,
  RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS,
  REVERT_QUEST_TO_DRAFT_SUCCESS,
  STOP_REVIEW_SUCCESS
} from '../actions/review'

import {
  IS_VIEWING_READABILITY_SCORES_MODAL,
  IS_NOT_VIEWING_READABILITY_SCORES_MODAL
} from '../actions/modal'
import {
  REQUEST_QUEST_TOPICS,
  RECEIVE_QUEST_TOPICS,
  DELETE_TOPIC_SUCCESS,
  EDIT_TOPIC_CONTEXT_SUCCESS,
  ADD_TOPIC_SUCCESS
} from '../actions/topics'
import {
  FETCH_QUEST_SKILLS_REQUEST,
  FETCH_QUEST_SKILLS_SUCCESS,
  DELETE_QUEST_SKILL_SUCCESS,
  ADD_QUEST_SKILL_SUCCESS
} from '../actions/questskills'
import { LOCATION_CHANGE } from 'react-router-redux'

const initialState = {
  isFetching: false,
  item: null,
  activities: [],
  section: null,
  subsection: null,
  activityId: null,
  notes: [],
  activityComments: [],
  comments: [],
  userComments: [],
  userActivityComments: [],
  topics: [],
  activityNotes: [],
  currentReviews: [],
  previousReviews: [],
  activeReview: null,
  isFetchingCompiledQuest: false,
  isUploadingNote: false,
  isEditingQuest: false,
  isDeletingNote: false,
  isAssigning: false,
  approvals: [],
  isEditingApproval: false,
  toQualityReviewModalIsOpen: false,
  viewingReadableScoresSection: '',
  viewingReadableScoresSubsection: '',
  error: null,
  analytics: null,
  isFetchingAnalytics: false,
  isUnassigning: false,
  isEditingComment: false,
  isSavingQuest: false,
  quest_events: [],
  isFetchingQuestHistory: false,
  historyPage: 0,
  historyTotal: 0,
  skills: [],
  isFetchingQuestSkills: false,
  isCreatingActivityResource: false,
  isSettingLastApproval: false,
  isFetchingQuestData: false
}

export function quest(state = initialState, action) {
  switch (action.type) {
    case START_FETCHING_QUEST_DATA: {
      return {
        ...initialState,
        isFetchingQuestData: true
      }
    }

    case END_FETCHING_QUEST_DATA: {
      return {
        ...state,
        isFetchingQuestData: false
      }
    }

    case REQUEST_QUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        item: { id: action.questId },
        currentReviews: [],
        previousReviews: [],
        activeReview: null,
        isEditingQuest: false,
        approvals: [],
        toQualityReviewModalIsOpen: false,
        error: null,
        quest_events: [],
        historyPage: null,
        historyTotal: null,
        isSettingLastApproval: false,
        isEditingApproval: false,
        activities: []
      })
    }

    case REQUEST_CURRENT_COMPILED_QUEST: {
      return Object.assign({}, state, {
        isFetchingCompiledQuest: true,
        currentReviews: [],
        previousReviews: [],
        activeReview: null
      })
    }

    case RECEIVE_QUEST:
      return Object.assign({}, state, {
        isFetching: false,
        item: action.quest,
        approvals: action.quest.quest_approvals
      })

    case REQUEST_QUEST_ACTIVITY_COMMENTS:
      return Object.assign({}, state, {
        activityComments: []
      })

    case RECEIVE_QUEST_ACTIVITY_COMMENTS: {
      return Object.assign({}, state, {
        activityComments: action.comments
      })
    }

    case REQUEST_QUEST_COMMENTS: {
      return Object.assign({}, state, {
        comments: []
      })
    }

    case RECEIVE_QUEST_COMMENTS: {
      return Object.assign({}, state, {
        comments: action.comments
      })
    }

    case FETCH_USER_ACTIVITY_COMMENTS_REQUEST: {
      return Object.assign({}, state, {
        userActivityComments: []
      })
    }

    case FETCH_USER_ACTIVITY_COMMENTS_SUCCESS: {
      return Object.assign({}, state, {
        userActivityComments: action.payload.comments
      })
    }

    case FETCH_USER_QUEST_COMMENTS_REQUEST: {
      return Object.assign({}, state, {
        userComments: []
      })
    }

    case FETCH_USER_QUEST_COMMENTS_SUCCESS: {
      return Object.assign({}, state, {
        userComments: action.payload.comments
      })
    }

    case REQUEST_QUEST_NOTES: {
      return Object.assign({}, state, {
        notes: []
      })
    }

    case RECEIVE_QUEST_NOTES: {
      return Object.assign({}, state, {
        notes: action.notes
      })
    }

    case REQUEST_QUEST_TOPICS: {
      return Object.assign({}, state, {
        topics: []
      })
    }

    case RECEIVE_QUEST_TOPICS: {
      return Object.assign({}, state, {
        topics: action.topics
      })
    }

    case SET_QUEST_SECTION:
      return Object.assign({}, state, {
        section: action.section,
        subsection: action.subsection || null,
        activityId: action.activityId,
        isEditingQuest: false,
        isEditingComment: false,
        error: null
      })
    case RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS:
      var activeReview = action.compiledQuest.reviews.find(function (review) {
        return review.completed_at === null
      })
      return Object.assign({}, state, {
        isFetchingCompiledQuest: false,
        activeReview: activeReview || null,
        currentReviews: action.compiledQuest.reviews,
        previousReviews: action.compiledQuest.previous_reviews
      })
    case CREATE_COMPILED_QUEST_REVIEW_SUCCESS:
      var reviews = []
      Object.assign(reviews, state.currentReviews)
      reviews.push(action.review)

      return Object.assign({}, state, {
        currentReviews: reviews,
        activeReview: action.review
      })
    case POST_QUEST_COMMENT:
      var postQuestComments = []
      Object.assign(postQuestComments, state.comments)
      postQuestComments.unshift(action.comment)

      return Object.assign({}, state, {
        comments: postQuestComments,
        isEditingComment: false
      })
    case POST_ACTIVITY_COMMENT:
      var postActivityComments = []
      Object.assign(postActivityComments, state.activityComments)
      postActivityComments.unshift(action.comment)

      return Object.assign({}, state, {
        activityComments: postActivityComments,
        isEditingComment: false
      })
    case POST_USER_QUEST_COMMENT:
      var postUserQuestComments = []
      Object.assign(postUserQuestComments, state.userComments)
      postUserQuestComments.unshift(action.comment)

      return Object.assign({}, state, {
        userComments: postUserQuestComments,
        isEditingComment: false
      })
    case POST_USER_ACTIVITY_COMMENT:
      var postUserActivityComments = []
      Object.assign(postUserActivityComments, state.userActivityComments)
      postUserActivityComments.unshift(action.comment)

      return Object.assign({}, state, {
        userActivityComments: postUserActivityComments,
        isEditingComment: false
      })
    case RESOLVE_QUEST_COMMENT:
      var comments = []
      Object.assign(
        comments,
        action.resourceType === 'Quest'
          ? state.comments
          : state.activityComments
      )
      comments.forEach(function (c) {
        if (c.id === action.commentId) {
          c.status = 1
        }
      })

      const newCommentsState =
        action.resourceType === 'Quest'
          ? {
              comments: comments
            }
          : {
              activityComments: comments
            }

      return Object.assign({}, state, newCommentsState)
    case OPEN_QUEST_COMMENT:
      var commentz = []
      Object.assign(
        commentz,
        action.resourceType === 'Quest'
          ? state.comments
          : state.activityComments
      )
      commentz.forEach(function (c) {
        if (c.id === action.commentId) {
          c.status = 0
        }
      })

      const newCommentzState =
        action.resourceType === 'Quest'
          ? {
              comments: commentz
            }
          : {
              activityComments: commentz
            }

      return Object.assign({}, state, newCommentzState)
    case EDIT_QUEST_COMMENT:
      var commentsEdit = []
      Object.assign(commentsEdit, state.comments)
      var editCommentIndex = commentsEdit.findIndex(function (thecomment) {
        return thecomment.id === action.commentId
      })
      commentsEdit.splice(editCommentIndex, 1, action.comment)

      return Object.assign({}, state, {
        comments: commentsEdit
      })

    case EDIT_ACTIVITY_COMMENT:
      var commentssEdit = []
      Object.assign(commentssEdit, state.activityComments)
      var editCommentIndexx = commentssEdit.findIndex(function (thecomment) {
        return thecomment.id === action.commentId
      })
      commentssEdit.splice(editCommentIndexx, 1, action.comment)

      return Object.assign({}, state, {
        activityComments: commentssEdit
      })

    case EDIT_DRAFT_QUEST_COMMENT:
      var draftCommentsEdit = []
      Object.assign(draftCommentsEdit, state.userComments)
      var editDraftCommentIndex = draftCommentsEdit.findIndex(function (
        thecomment
      ) {
        return thecomment.id === action.commentId
      })
      draftCommentsEdit.splice(editDraftCommentIndex, 1, action.comment)

      return Object.assign({}, state, {
        userComments: draftCommentsEdit,
        isEditingComment: false
      })

    case EDIT_DRAFT_ACTIVITY_COMMENT:
      var draftCommentsEditt = []
      Object.assign(draftCommentsEditt, state.userActivityComments)
      var editDraftCommentIndexx = draftCommentsEditt.findIndex(function (
        thecomment
      ) {
        return thecomment.id === action.commentId
      })
      draftCommentsEditt.splice(editDraftCommentIndexx, 1, action.comment)

      return Object.assign({}, state, {
        userActivityComments: draftCommentsEditt,
        isEditingComment: false
      })

    case PUBLISH_DRAFT_QUEST_COMMENT:
      var draftQuestCommentsEdit = []
      var questComments = []
      Object.assign(draftQuestCommentsEdit, state.userComments)
      Object.assign(questComments, state.comments)
      questComments.unshift(action.comment)
      const newQuestCommentsState = {
        userComments: draftQuestCommentsEdit.filter(
          c => c.id !== action.commentId
        ),
        comments: questComments,
        isEditingComment: false
      }

      return Object.assign({}, state, newQuestCommentsState)

    case PUBLISH_DRAFT_ACTIVITY_COMMENT:
      var draftActivityCommentsEdit = []
      var activityComments = []
      Object.assign(draftActivityCommentsEdit, state.userActivityComments)
      Object.assign(activityComments, state.activityComments)
      activityComments.unshift(action.comment)

      const newActivityCommentsState = {
        userActivityComments: draftActivityCommentsEdit.filter(
          c => c.id !== action.commentId
        ),
        activityComments: activityComments,
        isEditingComment: false
      }

      return Object.assign({}, state, newActivityCommentsState)

    case DELETE_QUEST_COMMENT:
      var questCommentss = []
      Object.assign(questCommentss, state.comments)

      const newQuestCommentssState = {
        comments: questCommentss.filter(function (c) {
          return c.id !== action.commentId
        })
      }

      return Object.assign({}, state, newQuestCommentssState)

    case DELETE_ACTIVITY_COMMENT:
      var activityCommentss = []
      Object.assign(activityCommentss, state.activityComments)

      const newActivityCommentssState = {
        activityComments: activityCommentss.filter(function (c) {
          return c.id !== action.commentId
        })
      }

      return Object.assign({}, state, newActivityCommentssState)

    case DELETE_DRAFT_QUEST_COMMENT:
      var draftQuestCommentss = []
      Object.assign(draftQuestCommentss, state.userComments)

      const newDraftQuestCommentssState = {
        userComments: draftQuestCommentss.filter(function (c) {
          return c.id !== action.commentId
        }),
        isEditingComment: false
      }

      return Object.assign({}, state, newDraftQuestCommentssState)

    case DELETE_DRAFT_ACTIVITY_COMMENT:
      var draftActivityCommentss = []
      Object.assign(draftActivityCommentss, state.userActivityComments)

      const newDraftActivityCommentssState = {
        userActivityComments: draftActivityCommentss.filter(function (c) {
          return c.id !== action.commentId
        }),
        isEditingComment: false
      }

      return Object.assign({}, state, newDraftActivityCommentssState)

    case IS_EDITING_COMMENT:
      return Object.assign({}, state, {
        isEditingComment: true
      })

    case IS_NOT_EDITING_COMMENT:
      return Object.assign({}, state, {
        isEditingComment: false
      })

    case REQUEST_QUEST_ACTIVITY_NOTES:
      return Object.assign({}, state, {
        activityNotes: []
      })
    case RECEIVE_QUEST_ACTIVITY_NOTES:
      return Object.assign({}, state, {
        activityNotes: action.notes
      })
    case CREATE_COMPILED_QUEST_SUCCESS:
      var previousReviews = []
      Object.assign(previousReviews, state.previousReviews)

      // Need to remove any current reviews that weren't completed due to recall
      // They will not be returned with the new compiled quest, when created
      var filteredCurrentReviews = []
      filteredCurrentReviews = state.currentReviews.filter(function (review) {
        return review.completed_at
      })
      var newPreviousReviews = previousReviews.concat(filteredCurrentReviews)
      // If it's the first compiled quest created from a published quest, need to remove previous reviews
      if (
        state.item.published_compiled_quest &&
        state.item.current_compiled_quest &&
        state.item.current_compiled_quest.state === 'published'
      ) {
        newPreviousReviews = []
      }

      var quest = {}
      Object.assign(quest, state.item)
      quest.reviewing_compiled_quest = action.payload.compiled_quest
      quest.current_compiled_quest = action.payload.compiled_quest

      return Object.assign({}, state, {
        item: quest,
        currentReviews: [],
        previousReviews: newPreviousReviews,
        activeReview: null,
        isSettingLastApproval: false
      })
    case DELETE_COMPILED_QUEST_REVIEW_SUCCESS:
      var reviewz = []
      Object.assign(reviewz, state.currentReviews)

      const newReviewzState = {
        currentReviews: reviewz.filter(function (r) {
          return r.id !== action.reviewId
        }),
        activeReview: null
      }

      return Object.assign({}, state, newReviewzState)
    case EDIT_REVIEW_SUCCESS:
      var reviewsEdit = []
      Object.assign(reviewsEdit, state.currentReviews)

      var editReviewIndex = reviewsEdit.findIndex(function (thereview) {
        return thereview.id === action.review.id
      })
      reviewsEdit[editReviewIndex] = action.review

      return Object.assign({}, state, {
        currentReviews: reviewsEdit,
        activeReview: action.review
      })
    case COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS:
      var reviewsssEdittt = []
      Object.assign(reviewsssEdittt, state.currentReviews)
      var editReviewIndexxxxx = reviewsssEdittt.findIndex(function (thereview) {
        return thereview.id === action.payload.review.id
      })
      reviewsssEdittt[editReviewIndexxxxx] = action.payload.review

      var questttt = {}
      Object.assign(questttt, state.item)
      const reviewState = action.payload.reviewState
      questttt.reviewing_compiled_quest.state = reviewState
      questttt.current_compiled_quest.state = reviewState
      if (reviewState === 'published') {
        const dateTime = +new Date()
        const timestamp = Math.floor(dateTime / 1000)
        questttt.published_compiled_quest = {
          state: 'published',
          published_at: timestamp
        }
      }

      const newReviewsssEditttState = {
        currentReviews: reviewsssEdittt,
        activeReview: null,
        item: questttt
      }

      return Object.assign({}, state, newReviewsssEditttState)
    case REVERT_QUEST_TO_DRAFT_SUCCESS: {
      var questtt = {}
      Object.assign(questtt, state.item)
      questtt.reviewing_compiled_quest = null
      questtt.current_compiled_quest.state = 'draft'

      var currentReviewsss = []
      Object.assign(currentReviewsss, state.currentReviews)
      var previousReviewsss = []
      Object.assign(previousReviewsss, state.previousReviews)

      if (action.payload.published) {
        currentReviewsss = []
        previousReviewsss = []
      }

      return Object.assign({}, state, {
        item: {
          ...questtt,
          ...action.payload.quest
        },
        currentReviews: currentReviewsss,
        previousReviews: previousReviewsss,
        approvals: []
      })
    }
    case STOP_REVIEW_SUCCESS: {
      var questt = {}
      Object.assign(questt, state.item)
      questt.reviewing_compiled_quest = null
      questt.current_compiled_quest.state = 'recalled'

      return Object.assign({}, state, {
        item: questt,
        approvals: []
      })
    }
    case DELETE_QUEST_SUCCESS: {
      return Object.assign({}, state, initialState)
    }
    case EDIT_QUEST_DETAILS_REQUEST: {
      return Object.assign({}, state, {
        isSavingQuest: true
      })
    }
    case EDIT_QUEST_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        item: {
          ...state.item,
          ...action.quest
        },
        isEditingQuest: false,
        error: null,
        isSavingQuest: false
      })
    }
    case EDIT_QUEST_DETAILS_FAILURE: {
      return Object.assign({}, state, {
        error: action.payload.error,
        isSavingQuest: false
      })
    }
    case CREATE_QUEST_MENTOR_NOTE_SUCCESS: {
      let newNotes = []
      Object.assign(newNotes, state.notes)
      newNotes.push(action.note)

      return Object.assign({}, state, {
        notes: newNotes,
        isUploadingNote: false
      })
    }
    case EDIT_QUEST_MENTOR_NOTE_SUCCESS: {
      let newNotes = []
      Object.assign(newNotes, state.notes)
      var editNoteIndex = newNotes.findIndex(function (note) {
        return note.id === action.payload.note.id
      })
      newNotes[editNoteIndex] = action.payload.note

      return Object.assign({}, state, {
        notes: newNotes,
        isUploadingNote: false
      })
    }
    case DELETE_NOTE_SUCCESS: {
      let newNotes = []
      Object.assign(newNotes, state.notes)
      const newNotesState = newNotes.filter(function (n) {
        return n.id !== action.noteId
      })

      return Object.assign({}, state, {
        notes: newNotesState,
        isDeletingNote: false
      })
    }
    case CREATE_MENTOR_NOTE: {
      return Object.assign({}, state, {
        isUploadingNote: true
      })
    }
    case START_EDIT_QUEST: {
      return Object.assign({}, state, {
        isEditingQuest: true
      })
    }
    case CANCEL_EDIT_QUEST: {
      return Object.assign({}, state, {
        isEditingQuest: false,
        isSavingQuest: false,
        error: null
      })
    }
    case DELETE_NOTE_REQUEST: {
      return Object.assign({}, state, {
        isDeletingNote: true
      })
    }
    case DELETE_ACTIVITY_SUCCESS: {
      let activities = []
      Object.assign(activities, state.activities)

      const deletedActivityIndex = activities.findIndex(function (a) {
        return a.id === action.activityId
      })

      const newActivitiesState = activities.filter(function (a) {
        return a.id !== action.activityId
      })

      var newActivityId = ''
      if (activities[deletedActivityIndex + 1]) {
        newActivityId = activities[deletedActivityIndex + 1].id
      } else if (activities[deletedActivityIndex - 1]) {
        newActivityId = activities[deletedActivityIndex - 1].id
      } else {
        newActivityId = null
      }

      return Object.assign({}, state, {
        activities: newActivitiesState,
        activityId: newActivityId
      })
    }

    case EDIT_ACTIVITY_DETAILS_SUCCESS: {
      let activities = []
      Object.assign(activities, state.activities)

      const editActivityIndex = activities.findIndex(function (a) {
        return a.id === action.activityId
      })

      Object.keys(action.activity).forEach(function (k) {
        activities[editActivityIndex][k] = action.activity[k]
      })

      return Object.assign({}, state, {
        activities,
        isFetching: false
      })
    }
    case DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS: {
      var activityNotes = []
      Object.assign(activityNotes, state.activityNotes)
      const newActivityNotesState = activityNotes.filter(function (n) {
        return n.id !== action.noteId
      })
      return Object.assign({}, state, {
        activityNotes: newActivityNotesState
      })
    }
    case CREATE_QUEST_ACTIVITY_NOTE_SUCCESS: {
      var activityNotess = []
      Object.assign(activityNotess, state.activityNotes)
      activityNotess.push(action.note)
      return Object.assign({}, state, {
        activityNotes: activityNotess,
        isUploadingNote: false
      })
    }
    case EDIT_QUEST_ACTIVITY_NOTE_REQUEST: {
      return Object.assign({}, state, {
        isUploadingNote: true
      })
    }
    case EDIT_QUEST_ACTIVITY_NOTE_SUCCESS: {
      var activityNotesss = []
      Object.assign(activityNotesss, state.activityNotes)

      const editActivityNoteIndex = activityNotesss.findIndex(function (n) {
        return n.id === action.note.id
      })
      activityNotesss[editActivityNoteIndex] = action.note

      return Object.assign({}, state, {
        activityNotes: activityNotesss,
        isUploadingNote: false
      })
    }
    case EDIT_QUEST_ACTIVITY_NOTE_FAILURE: {
      return Object.assign({}, state, {
        isUploadingNote: false,
        statusText: action.payload.statusText
      })
    }
    case DELETE_TOPIC_SUCCESS: {
      var topics = []
      Object.assign(topics, state.topics)
      const newTopicsState = topics.filter(function (t) {
        return t.topic_id !== action.topicId
      })

      return Object.assign({}, state, {
        topics: newTopicsState
      })
    }
    case EDIT_TOPIC_CONTEXT_SUCCESS: {
      var topicss = []
      Object.assign(topicss, state.topics)

      const editTopicIndex = topicss.findIndex(function (t) {
        return t.topic_id === action.topic.topic_id
      })
      topicss[editTopicIndex] = action.topic

      return Object.assign({}, state, {
        topics: topicss
      })
    }
    case ADD_TOPIC_SUCCESS: {
      var topicsss = []
      Object.assign(topicsss, state.topics)
      topicsss.push(action.topic)
      return Object.assign({}, state, {
        topics: topicsss
      })
    }
    case EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS: {
      let activityNotes = []
      Object.assign(activityNotes, state.activityNotes)
      const oldNoteIndex = activityNotes.findIndex(function (n) {
        return n.id === action.note.id
      })
      // replace the note in the array
      activityNotes[oldNoteIndex] = action.note
      // reorder the array
      activityNotes.splice(
        action.newIndex,
        0,
        activityNotes.splice(oldNoteIndex, 1)[0]
      )
      return Object.assign({}, state, {
        activityNotes: activityNotes
      })
    }

    case DELETE_ACTIVITY_RESOURCE_SUCCESS: {
      let activities = []
      Object.assign(activities, state.activities)
      const editActivityIndexx = activities.findIndex(function (a) {
        return a.id === action.activityId
      })
      const activityResourceEdit = activities[
        editActivityIndexx
      ].resources.filter(function (r) {
        return r.id !== action.resourceId
      })
      activities[editActivityIndexx].resources = activityResourceEdit
      return Object.assign({}, state, {
        activities
      })
    }

    case EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS: {
      // TODO: refactor this mess; the resource is so deeply nested
      let activities = []
      Object.assign(activities, state.activities)
      // Find the right activity
      const editActivityIndexxx = activities.findIndex(function (a) {
        return a.id === action.resource.activity_id
      })
      // Find the resource within the activity
      const oldResourceIndex = activities[
        editActivityIndexxx
      ].resources.findIndex(function (r) {
        return r.id === action.resource.id
      })
      // replace the resource in the array
      activities[editActivityIndexxx].resources[oldResourceIndex] =
        action.resource
      // reorder the array of resources
      activities[editActivityIndexxx].resources.splice(
        action.newIndex,
        0,
        activities[editActivityIndexxx].resources.splice(oldResourceIndex, 1)[0]
      )
      return Object.assign({}, state, {
        activities
      })
    }

    case CREATE_ACTIVITY_RESOURCE_REQUEST: {
      return Object.assign({}, state, {
        isCreatingActivityResource: true
      })
    }

    case CREATE_ACTIVITY_RESOURCE_SUCCESS: {
      let activities = []
      Object.assign(activities, state.activities)
      // Find the activity
      const editActivityIndexxxx = activities.findIndex(function (a) {
        return a.id === action.resource.activity_id
      })
      activities[editActivityIndexxxx].resources.unshift(action.resource)
      return Object.assign({}, state, {
        activities,
        isCreatingActivityResource: false
      })
    }

    case CREATE_ACTIVITY_RESOURCE_FAILURE: {
      return Object.assign({}, state, {
        isCreatingActivityResource: false
      })
    }

    case EDIT_ACTIVITY_RESOURCE_SUCCESS: {
      // TODO: refactor this mess; the resource is so deeply nested
      let activities = []
      Object.assign(activities, state.activities)
      // Find the right activity
      const editActivityIndexxxxx = activities.findIndex(function (a) {
        return a.id === action.resource.activity_id
      })
      // Find the resource within the activity
      const oldResourceIndexx = activities[
        editActivityIndexxxxx
      ].resources.findIndex(function (r) {
        return r.id === action.resource.id
      })
      // replace the resource in the array
      activities[editActivityIndexxxxx].resources[oldResourceIndexx] =
        action.resource
      return Object.assign({}, state, {
        activities,
        isUploadingNote: false
      })
    }

    case EDIT_ACTIVITY_RESOURCE_REQUEST: {
      return Object.assign({}, state, {
        isUploadingNote: true
      })
    }

    case EDIT_ACTIVITY_RESOURCE_FAILURE: {
      return Object.assign({}, state, {
        isUploadingNote: false
      })
    }

    case CREATE_ACTIVITY_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case CREATE_ACTIVITY_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case CREATE_ACTIVITY_SUCCESS: {
      let quest = {}
      Object.assign(quest, state.item)

      let activities = []
      Object.assign(activities, state.activities)

      // Need to add properties as they are not included in the response
      const formattedActivity = {
        ...action.activity,
        resources: [],
        quest_icon_url: state.item.icon_image_url,
        quest_name: state.item.name
      }

      quest.activity_count += 1
      activities.push(formattedActivity)

      return Object.assign({}, state, {
        activities,
        isFetching: false,
        item: quest,
        activityId: action.activity.id,
        activityNotes: [],
        activityComments: []
      })
    }

    case EDIT_ACTIVITY_POSITION_SUCCESS: {
      let activities = []
      Object.assign(activities, state.activities)

      // Find the right activity
      const editActivityPositionIndex = activities.findIndex(function (a) {
        return a.id === action.payload.activityId
      })

      // reorder the array of activities
      activities.splice(
        action.payload.newIndex,
        0,
        activities.splice(editActivityPositionIndex, 1)[0]
      )

      return Object.assign({}, state, {
        activities
      })
    }

    case EDIT_ACTIVITY_DETAILS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case EDIT_ACTIVITY_DETAILS_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case CREATE_QUEST_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case CREATE_QUEST_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case CREATE_QUEST_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        item: {
          ...action.quest,
          grade_levels: []
        }
      })
    }

    case ADD_EDITOR_TO_QUEST: {
      var questtttttt = {}
      Object.assign(questtttttt, state.item)
      const editor = questtttttt.editors.find(function (editor) {
        return editor.id === action.payload.user.id
      })
      if (!editor) {
        questtttttt.editors.push(action.payload.user)
      }
      return Object.assign({}, state, {
        item: questtttttt
      })
    }

    case FETCH_TOPIC_CLOUD_REQUEST: {
      return Object.assign({}, state, {
        ...initialState
      })
    }

    case IS_ASSIGNING: {
      return Object.assign({}, state, {
        isAssigning: true
      })
    }

    case IS_NOT_ASSIGNING: {
      return Object.assign({}, state, {
        isAssigning: false
      })
    }

    case ASSIGN_QUEST_TO_USER_SUCCESS: {
      return {
        ...state,
        item: {
          ...state.item,
          assigned_by: {
            id: action.payload.currentUser.id,
            photo_url: action.payload.currentUser.photo.url,
            name: action.payload.currentUser.name,
            display_name: action.payload.currentUser.display_name
          },
          assigned_to: action.payload.assignment.assigned_to,
          assignment_updated_at: action.payload.assignment.created_at,
          assignment_message: action.payload.assignment.message,
          current_quest_assignment_id: action.payload.assignment.id
        }
      }
    }

    case IS_EDITING_APPROVAL: {
      return {
        ...state,
        isEditingApproval: true
      }
    }

    case SET_APPROVED_SUCCESS: {
      var approvals = []
      Object.assign(approvals, state.approvals)
      approvals.push(action.payload.approval)

      return Object.assign({}, state, {
        approvals: approvals,
        isEditingApproval: false
      })
    }

    case DELETE_APPROVED_SUCCESS: {
      const approvalss = state.approvals.filter(
        approval => approval.id !== action.payload.approvalId
      )
      return Object.assign({}, state, {
        approvals: approvalss,
        isEditingApproval: false
      })
    }

    case OPEN_TO_QUALITY_REVIEW_MODAL: {
      return Object.assign({}, state, {
        toQualityReviewModalIsOpen: true
      })
    }

    case CLOSE_TO_QUALITY_REVIEW_MODAL: {
      return Object.assign({}, state, {
        toQualityReviewModalIsOpen: false,
        isEditingApproval: false,
        isSettingLastApproval: false
      })
    }

    case IS_VIEWING_READABILITY_SCORES_MODAL: {
      return Object.assign({}, state, {
        viewingReadableScoresSection: action.payload.section,
        viewingReadableScoresSubsection: action.payload.subsection
      })
    }

    case IS_NOT_VIEWING_READABILITY_SCORES_MODAL: {
      return Object.assign({}, state, {
        viewingReadableScoresSection: '',
        viewingReadableScoresSubsection: ''
      })
    }

    case RECEIVE_QUEST_READABLE_STATS: {
      return Object.assign({}, state, {
        item: {
          ...state.item,
          readable_stats: action.payload.stats
        }
      })
    }

    case REQUEST_QUEST_ANALYTICS: {
      return Object.assign({}, state, {
        analytics: null,
        isFetchingAnalytics: true
      })
    }

    case FAILED_QUEST_ANALYTICS: {
      return Object.assign({}, state, {
        analytics: null,
        isFetchingAnalytics: false
      })
    }

    case RECEIVE_QUEST_ANALYTICS: {
      return Object.assign({}, state, {
        analytics: action.payload.quest_analytics,
        isFetchingAnalytics: false
      })
    }

    case RECEIVE_ACTIVITY_READABLE_STATS: {
      let activities = []
      Object.assign(activities, state.activities)

      activities = activities.map(function (a) {
        if (a.id === state.activityId) {
          return {
            ...a,
            readable_stats: action.payload.stats
          }
        } else {
          return a
        }
      })

      return Object.assign({}, state, {
        activities
      })
    }

    case IS_UNASSIGNING: {
      return Object.assign({}, state, {
        isUnassigning: true
      })
    }

    case IS_NOT_UNASSIGNING: {
      return Object.assign({}, state, {
        isUnassigning: false
      })
    }

    case UNASSIGN_QUEST_FROM_USER_SUCCESS: {
      return {
        ...state,
        item: {
          ...state.item,
          assigned_by: null,
          assigned_to: null,
          assignment_updated_at: null,
          assignment_message: null
        }
      }
    }

    case REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS: {
      // TODO: refactor this mess; the resource is so deeply nested
      let activities = []
      Object.assign(activities, state.activities)

      // Find the right activity
      const editActivityIndex = activities.findIndex(function (a) {
        return a.id === action.resource.activity_id
      })

      // Find the resource within the activity
      const oldResourceIndexxx = activities[
        editActivityIndex
      ].resources.findIndex(function (r) {
        return r.id === action.resource.id
      })

      // replace the resource in the array
      activities[editActivityIndex].resources[oldResourceIndexxx] = {
        ...action.resource,
        file: null,
        file_name: null,
        file_url: null,
        format: 'file',
        fileRemoved: true
      }

      return Object.assign({}, state, {
        activities
      })
    }

    case FETCH_QUEST_HISTORY_REQUEST: {
      let questEvents = Array.from(state.quest_events)
      if (action.payload.reload) {
        questEvents = []
      }
      return {
        ...state,
        isFetchingQuestHistory: true,
        quest_events: questEvents
      }
    }

    case FETCH_QUEST_HISTORY_SUCCESS: {
      let events = []
      Object.assign(events, state.quest_events)

      action.payload.quest_events.forEach(function (item) {
        events.push(item)
      })

      const idPositions = events.map(item => item.id)
      const newPayload = events.filter((item, pos, arr) => {
        return idPositions.indexOf(item.id) === pos
      })

      return Object.assign({}, state, {
        isFetchingQuestHistory: false,
        quest_events: newPayload,
        historyPage: action.payload.page,
        historyTotal: action.payload.total
      })
    }

    case CLEAR_QUEST_HISTORY: {
      return {
        ...state,
        quest_events: [],
        historyPage: 0,
        historyTotal: 0
      }
    }

    case FETCH_QUEST_SKILLS_REQUEST: {
      return {
        ...state,
        isFetchingQuestSkills: true
      }
    }

    case FETCH_QUEST_SKILLS_SUCCESS: {
      return {
        ...state,
        isFetchingQuestSkills: false,
        skills: action.payload.skills
      }
    }

    case ADD_QUEST_SKILL_SUCCESS: {
      let skills = []
      Object.assign(skills, state.skills)
      skills.unshift(action.payload.skill)

      return {
        ...state,
        skills: skills
      }
    }

    case DELETE_QUEST_SKILL_SUCCESS: {
      let skills = []
      Object.assign(skills, state.skills)
      const newSkillsState = skills.filter(skill => {
        return skill.framework_skill_id !== action.payload.skillId
      })

      return Object.assign({}, state, {
        skills: newSkillsState
      })
    }

    case PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS: {
      // TODO: refactor this mess; the resource is so deeply nested
      let activities = []
      Object.assign(activities, state.activities)

      // add prop to resource for updating the component appropriately
      const patchedResource = {
        ...action.payload.resource
      }

      // Find the right activity
      const editActivityIndex = activities.findIndex(function (a) {
        return a.id === patchedResource.activity_id
      })

      // Find the resource within the activity
      const oldResourceIndex = activities[
        editActivityIndex
      ].resources.findIndex(function (r) {
        return r.id === patchedResource.id
      })

      // replace the resource in the array
      activities[editActivityIndex].resources[oldResourceIndex] =
        patchedResource

      return Object.assign({}, state, {
        activities
      })
    }

    case IS_SETTING_LAST_APPROVAL: {
      return {
        ...state,
        isSettingLastApproval: true
      }
    }

    // make sure to clear error in case a user navigates away before canceling/saving
    case LOCATION_CHANGE: {
      return {
        ...state,
        error: null
      }
    }

    case FETCH_QUEST_ACTIVITIES_SUCCESS: {
      return {
        ...state,
        activities: action.payload.activities
      }
    }

    case FETCH_IN_USE_COMPILED_QUESTS_SUCCESS: {
      return {
        ...state,
        item: {
          ...state.item,
          reviewing_compiled_quest:
            action.payload.inUseCompiledQuests.reviewing_compiled_quest,
          published_compiled_quest:
            action.payload.inUseCompiledQuests.published_compiled_quest,
          current_compiled_quest:
            action.payload.inUseCompiledQuests.current_compiled_quest
        }
      }
    }

    case FETCH_CURRENT_ASSIGNMENT_SUCCESS: {
      return {
        ...state,
        item: {
          ...state.item,
          assigned_by: action.payload.assignment.assigned_by,
          assigned_to: action.payload.assignment.assigned_to,
          assignment_type: action.payload.assignment.assignment_type,
          assignment_message: action.payload.assignment.message,
          assignment_updated_at: action.payload.assignment.updated_at,
          current_quest_assignment_id: action.payload.assignment.id
        }
      }
    }

    case FETCH_QUEST_APPROVALS_SUCCESS: {
      return {
        ...state,
        approvals: action.payload.approvals
      }
    }

    case FETCH_QUEST_GRADE_LEVELS_SUCCESS: {
      return {
        ...state,
        item: {
          ...state.item,
          grade_levels: action.payload.gradeLevels
        }
      }
    }

    case UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS: {
      return {
        ...state,
        isSavingQuest: false,
        item: {
          ...state.item,
          color: action.payload.imageProperties.color,
          icon_image_url: action.payload.imageProperties.icon_image_url,
          icon_image_license_properties:
            action.payload.imageProperties.icon_image_license_properties,
          icon_image_original_file_name:
            action.payload.imageProperties.icon_image_original_file_name
        }
      }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/quest.js